import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ProfileForm = ({ formData, errors, onChange, onSave, isSaving }) => {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Edit3" size={16} className="text-accent" />
        <h3 className="text-base font-semibold text-foreground">Personal Information</h3>
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <Input
              label="First Name"
              type="text"
              placeholder="Enter first name"
              value={formData?.firstName}
              onChange={(e) => onChange('firstName', e?.target?.value)}
              error={errors?.firstName}
              required
            />
          </div>
          <div>
            <Input
              label="Last Name"
              type="text"
              placeholder="Enter last name"
              value={formData?.lastName}
              onChange={(e) => onChange('lastName', e?.target?.value)}
              error={errors?.lastName}
              required
            />
          </div>
        </div>

        <div>
          <Input
            label="Nickname"
            type="text"
            placeholder="Enter nickname (optional)"
            value={formData?.nickname}
            onChange={(e) => onChange('nickname', e?.target?.value)}
            error={errors?.nickname}
          />
          <p className="text-xs text-muted-foreground mt-1">
            Nickname is used in project assignments and mentions throughout the app.
          </p>
        </div>

        <div className="flex justify-end pt-2">
          <Button
            variant="default"
            onClick={onSave}
            disabled={isSaving}
            iconName={isSaving ? 'Loader2' : 'Save'}
            iconPosition="left"
          >
            {isSaving ? 'Saving...' : 'Save Changes'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProfileForm;
